import { getDateFromTimestamp } from './utils/getDateFromTimestamp';
import { getOddsInCent } from './utils/getOddsInCent';


function getCheckPointsTemplate21(rules, coupon, dateEnd, isBetBuilder){
	const checkPoints = {};
	let amount = 0;
	if(isBetBuilder){
		amount = coupon.amountMulti;
	}
	else {
		switch(coupon.selectedContainer){
			case 'singlebets' : { amount = coupon.amountSingle; break;}
			case 'multibets'  : { amount = coupon.amountMulti; break;}
			case 'systembets' : { amount = coupon.amountSystem; break;}
		}	
	}


	let totalOdd = getOddsInCent(coupon.totalOdd);
	const minOdd = rules.min_odd;
	let selectionsGoodTot = 0;
	let totalSelections = 0;
	// 50% del peso della percentuale da mostrare al cliente
	// viene riservato al raggiungimento minimo di selezioni coerenti con la promo
	const percentualePesoSelezioni = 70;
	const percentualePesoMarginali = 100 - percentualePesoSelezioni;
	const pesoSelezioni = rules.min_eve * 100 //moltiplico per 100 per aumentare precisione;
	
	// es con 60%: sapendo che deve essere vera la seguente proporzione 
	// 40 : 100 = pesoSelezioni : pesoTotale;
	// ottengo questo sistema di equazioni
	// pesoSelezioni = (40 * pesoTotale) / 100
	// pesoTotale = pesoSelezioni + pesoSelezioni;
	// pesoSelezioni = (20 * (pesoSelezioni + pesoSelezioni)) / 100 cioe'
	const pesoMarginali = parseInt((percentualePesoMarginali * pesoSelezioni) / percentualePesoSelezioni);
	const pesoSingolaSelezione = parseInt(pesoSelezioni/rules.min_eve);
	
	let eventFound = false;
	const eventSpecified = rules.palinsesto != 0 || rules.avvenimento != 0;
	if(eventSpecified){
		for(let ks in coupon.selections){
			const selection = coupon.selections[ks];
			eventFound = eventFound || (selection.pal == rules.palinsesto && selection.avv == rules.avvenimento);
		}	
	}
	

	for(let ks in coupon.selections){
		const selection = coupon.selections[ks];
		// l'evento è valido se: non e' stato specificato un pal.avv
		// se è stato specificato ed è proprio quell'evento
		// se max_eve > 1 e l'evento è presente in un altra selezione
		const eventoPalAvvOk = ((selection.pal == rules.palinsesto && selection.avv == rules.avvenimento)  || 
								(!eventSpecified)) ||
								(eventFound && rules.min_eve > 1);
		let eventoDataOk = true;
		if(dateEnd?.length > 0){
			const eventDate = getDateFromTimestamp(selection.timestamp);
			const endDate = getDateFromTimestamp(dateEnd);
			eventoDataOk = eventDate.getTime() < endDate.getTime();
		}
		const sportOk = (Object.keys(rules.whitelistSport).length === 0 || rules.whitelistSport[selection.sportId]);
		const tournOk = (Object.keys(rules.whitelistTornei).length === 0 || rules.whitelistTornei[selection.tournamentId]);
		if(coupon.selections.length === 1 && coupon.selectedContainer === 'singlebets'){
			totalOdd = selection.bets[0].odd;
		}
		const liveSel = selection.isLive;
		const prematchSel = !selection.isLive;
		const liveOk = ((rules.live == 0 && !liveSel) || (rules.live == 1));
		const prematchOk = ((rules.prematch == 0 && !prematchSel) || (rules.prematch == 1));
		betsFor : for(let kb in selection.bets){
			const minOddOk = selection.bets[kb].odd >= minOdd;
			const betOk = (selection.bets[kb].scomSogei == rules.scommessa || (rules.scommessa == 0) || !rules.scommessa);
			const selectionIsGood = eventoPalAvvOk && 
								    sportOk  &&
								    tournOk &&
								    minOddOk &&
								    betOk &&
								    liveOk &&
								    prematchOk &&
								    eventoDataOk;
			if(selectionIsGood){
				selectionsGoodTot ++;
			}
			totalSelections ++;
			checkPoints["selection-" + totalSelections] = {ok : selectionIsGood, pesoPerc : pesoSingolaSelezione}; 
			if(coupon.selectedContainer === 'singlebets'){
				break betsFor;
			}
		}
	}
	const allSelectionAreOk = totalSelections == selectionsGoodTot;
	if(!allSelectionAreOk){
		// tutte le selezioni devono essere messe a false
		for(let kc in checkPoints){
			if((kc + "").indexOf("selection") == 0){
				checkPoints[kc].ok = false;
			}
		}
	}
	// scelgo di considerare i check point "esterni" alle selezioni solo se tutte le selezioni sono buone. In questo modo avrò 0% se c'è almeno una selezione non buona
	// e poi, do un peso specifico alla percentuale (dando priorità al numero di selezioni)
	
	let dividendoPesiMarginali = 1;
	if(rules.max_eve > 0){
		dividendoPesiMarginali ++;
	}
	if(rules.tot_odd > 0){
		dividendoPesiMarginali ++;
	}
	const pesoSingoloMarginale = parseInt(pesoMarginali / dividendoPesiMarginali);
	checkPoints['checkMinEveOk'] = {ok : allSelectionAreOk && selectionsGoodTot >= rules.min_eve, pesoPerc :  pesoSingoloMarginale}; 
	checkPoints['checkMaxEveOk'] = {ok: allSelectionAreOk && (rules.max_eve == 0 || selectionsGoodTot <= rules.max_eve), pesoPerc : rules.max_eve == 0? 0 : pesoSingoloMarginale};
	checkPoints['checkTotOddOk'] = {ok: allSelectionAreOk && (rules.tot_odd == 0 || totalOdd >= rules.tot_odd), pesoPerc: rules.tot_odd == 0? 0 : pesoSingoloMarginale};
	checkPoints['checkMinStake'] = {ok : allSelectionAreOk && amount >= rules.minBet, pesoPerc :  pesoSingoloMarginale}; 
	checkPoints['checkMaxStake'] = {ok : allSelectionAreOk && (rules.maxBet == 0 || amount <= rules.maxBet), pesoPerc :  pesoSingoloMarginale}; 
	return checkPoints;
}

function getCheckPointsTemplatePerdite11(rules, coupon, dateEnd, isBetBuilder){
	const checkPoints = {};
	let amount = 0;
	if(isBetBuilder){
		amount = coupon.amountMulti;
	}
	else {
		switch(coupon.selectedContainer){
			case 'singlebets' : { amount = coupon.amountSingle; break;}
			case 'multibets'  : { amount = coupon.amountMulti; break;}
			case 'systembets' : { amount = coupon.amountSystem; break;}
		}	
	}
	let selectionsGoodTot = 0;
	let totalSelections = 0;
	// 50% del peso della percentuale da mostrare al cliente
	// viene riservato al raggiungimento minimo di selezioni coerenti con la promo
	const percentualePesoSelezioni = 70;
	const percentualePesoMarginali = 100 - percentualePesoSelezioni;
	const pesoSelezioni = rules.min_eve * 100 //moltiplico per 100 per aumentare precisione;
	
	// es con 60%: sapendo che deve essere vera la seguente proporzione 
	// 40 : 100 = pesoSelezioni : pesoTotale;
	// ottengo questo sistema di equazioni
	// pesoSelezioni = (40 * pesoTotale) / 100
	// pesoTotale = pesoSelezioni + pesoSelezioni;
	// pesoSelezioni = (20 * (pesoSelezioni + pesoSelezioni)) / 100 cioe'
	const pesoMarginali = parseInt((percentualePesoMarginali * pesoSelezioni) / percentualePesoSelezioni);
	const pesoSingolaSelezione = parseInt(pesoSelezioni/rules.min_eve);
	let totalOdd = getOddsInCent(coupon.totalOdd);
	const minOdd = rules.min_odd;
	for(let ks in coupon.selections){
		const selection = coupon.selections[ks];
		const prematchOk = !selection.isLive;
		const sportOk = (Object.keys(rules.whitelistSport).length === 0 || rules.whitelistSport[selection.sportId]);
		const tournOk = (Object.keys(rules.whitelistTornei).length === 0 || rules.whitelistTornei[selection.tournamentId]);
		let eventoDataOk = true;
		if(dateEnd?.length > 0){
			const eventDate = getDateFromTimestamp(selection.timestamp);
			const endDate = getDateFromTimestamp(dateEnd);
			eventoDataOk = eventDate.getTime() < endDate.getTime();
		}
		if(coupon.selections.length === 1 && coupon.selectedContainer === 'singlebets'){
			totalOdd = selection.bets[0].odd;
		}
		betsFor: for(let kb in selection.bets){
			const minOddOk = selection.bets[kb].odd >= minOdd;
			const betOk = (selection.bets[kb].scomSogei == rules.scommessa || (rules.scommessa == 0) || !rules.scommessa);
			const selectionIsGood = sportOk  &&
								    tournOk &&
								    minOddOk &&
								    betOk &&
								    prematchOk &&
								    eventoDataOk;
			if(selectionIsGood){
				selectionsGoodTot ++;
			}
			totalSelections ++;
			checkPoints["selection-" + totalSelections] = {ok : selectionIsGood, pesoPerc : pesoSingolaSelezione}; 
			if(coupon.selectedContainer === 'singlebets'){
				break betsFor;
			}
		}
	}
	const allSelectionAreOk = totalSelections == selectionsGoodTot;
	if(!allSelectionAreOk){
		// tutte le selezioni devono essere messe a false
		for(let kc in checkPoints){
			if((kc + "").indexOf("selection") == 0){
				checkPoints[kc].ok = false;
			}
		}
	}
	let dividendoPesiMarginali = 1;
	const pesoSingoloMarginale = parseInt(pesoMarginali / dividendoPesiMarginali);
	if(rules.max_eve > 0){
		dividendoPesiMarginali ++;
	}
	if(rules.tot_odd > 0){
		dividendoPesiMarginali ++;
	}
	checkPoints['checkMinEveOk'] = {ok : allSelectionAreOk && selectionsGoodTot >= rules.min_eve, pesoPerc :  pesoSingoloMarginale}; 
	checkPoints['checkMaxEveOk'] = {ok: allSelectionAreOk && (rules.max_eve == 0 || selectionsGoodTot <= rules.max_eve), pesoPerc : rules.max_eve == 0? 0 : pesoSingoloMarginale};
	checkPoints['checkTotOddOk'] = {ok: allSelectionAreOk && (rules.tot_odd == 0 || totalOdd >= rules.tot_odd), pesoPerc: rules.tot_odd == 0? 0 : pesoSingoloMarginale};
	checkPoints['checkMinStake'] = {ok : allSelectionAreOk && amount >= rules.minBet, pesoPerc :  pesoSingoloMarginale}; 
	checkPoints['checkMaxStake'] = {ok : allSelectionAreOk && (rules.maxBet == 0 || amount <= rules.maxBet), pesoPerc :  pesoSingoloMarginale}; 
	return checkPoints;
}

export function isPromoToggleable(promo, coupon, isBetBuilder){
	if(promo.activated){
		return {
			toggleable : false,
			percentage : '100%'
		}	
	}
	const rules = promo.rules;
	let checkPoints = null;
	const isBetBuilderAvailableForPromos = false; // mettere in conf
	if(coupon.selectedContainer === 'multibets' || 
	  (isBetBuilder && isBetBuilderAvailableForPromos) ||
	  (coupon.selectedContainer === 'singlebets' && coupon.selections?.length == 1 && coupon.selections[0].bets?.length === 1)){
		switch(promo.template){
			case 'dbo.JobBonusPSQFTemplate21': {checkPoints = getCheckPointsTemplate21(rules, coupon, promo.end_date, isBetBuilder); break }
			case 'dbo.JobBonusPerditePSQFTemplate11': {checkPoints = getCheckPointsTemplatePerdite11(rules, coupon, promo.end_date, isBetBuilder); break }
			default:{ break }
		}
	}
	if(!checkPoints){
		return {
			toggleable : false,
			percentage : '0%'
		}
	}
	let toggleable = true;
	let checkPassedWeight =  0;
	let totalWeight = 0;
	for (let kc in checkPoints){
		toggleable &= checkPoints[kc].ok;
		if(checkPoints[kc].ok){
			checkPassedWeight += checkPoints[kc].pesoPerc;
		}
		totalWeight += checkPoints[kc].pesoPerc;
	}
	const percentage = parseInt((checkPassedWeight * 100) / totalWeight)  + "%";
	if(promo.activated){
		toggleable = false;
	}
	return {
		toggleable,
		percentage
	};
}

export function urlify(text) {
  var urlRegex = /(https?:\/\/[^\s]+)/g;
  return text.replace(urlRegex, function(url) {
    return '<a href="' + url + '">' + url + '</a>';
  })
}